export interface IHowToAction {
    id: number;
    actionName: string;
    description: string;
    actionImageUrl: string;
    howToId: number;
    howToName: string;
  }
  
  export interface IHowTo {
    id: number;
    name: string;
    purpose: string;
    videoTitle: string;
    videoDescription: string;
    videoLink: string;
    videoEmbedCode: string;
    altVideoLink: string;
    location: number;
    locationName: string;
    status: number;
    statusName: string;
    createdOn: Date;
    howToActionModels: IHowToAction[];
  }
  